import {
  UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS,
  UPDATEORADDWALLETOWNERBANKDETAILS_FAILED,
  RESET_UPDATEORADDWALLETOWNERBANKDETAILS,
  LOADING_UPDATEORADDWALLETOWNERBANKDETAILS,
  NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEORADDWALLETOWNERBANKDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEORADDWALLETOWNERBANKDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEORADDWALLETOWNERBANKDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
